import {
  MdDashboard,
  MdOutlineMessage,
  MdSettingsApplications,
  MdBrowserUpdated,
} from "react-icons/md";
import { BsCalendar2DateFill, BsCalendar2RangeFill } from "react-icons/bs";
import {
  FaBook,
  FaCartPlus,
  FaEuroSign,
  FaStar,
  FaCheckCircle,
  FaQuestionCircle,
  FaLaptopCode,
} from "react-icons/fa";
import { BsKanban } from "react-icons/bs";
import { FiActivity } from "react-icons/fi";
import { FaHandshake } from "react-icons/fa6";
import { IoPersonAddSharp } from "react-icons/io5";
import { RiMailForbidFill } from "react-icons/ri";
import { SiGoogleforms } from "react-icons/si";
import { MdTrackChanges } from "react-icons/md";

export const DASHBOARD_BASE_PATH = "/appli";

export const ROLE_LABELS = {
  1: "Administrateur",
  2: "Utilisateur",
  3: "Client",
};

export const DASHBOARD_BRAND = {
  name: "MonAppliClub",
  title: "Dashboard",
  icon: MdSettingsApplications,
};

export const DASHBOARD_MENUS = {
  1: [
    {
      title: "Activités des sites",
      path: "site-activity",
      icon: FiActivity,
      badgeKey: "pendingRequests",
    },
    {
      title: "Visiteurs",
      path: "visiteurs",
      icon: MdTrackChanges,
      badgeKey: "visitorAlerts",
    },
    {
      title: "Tableau de bord",
      path: "dashboard-admin",
      icon: MdDashboard,
    },
    {
      title: "Contact Formulaire",
      path: "contact-form",
      icon: MdOutlineMessage,
      badgeKey: "contactForms",
    },
    {
      title: "Prospects",
      path: "prospects",
      icon: IoPersonAddSharp,
    },
    {
      title: "Listing Clients",
      path: "listing-clients",
      icon: FaStar,
    },
    {
      title: "Prospection",
      path: "prospection",
      icon: SiGoogleforms,
    },
    {
      title: "Parrainage",
      path: "parrainage",
      icon: FaHandshake,
      badgeKey: "parrainages",
    },
    {
      title: "Échéances / dépenses",
      path: "echeances",
      icon: BsCalendar2DateFill,
    },
    {
      title: "Produits",
      path: "products",
      icon: FaCartPlus,
    },
    {
      title: "Produits Applications",
      path: "products-app",
      icon: FaLaptopCode,
    },
    {
      title: "Tutoriel MonAppliClub",
      path: "tutorials",
      icon: FaBook,
    },
    {
      title: "Abonnements",
      path: "subscriptions",
      icon: BsCalendar2RangeFill,
      badgeKey: "subscriptions",
    },
    {
      title: "Mise à jour",
      path: "mise-a-jour",
      icon: MdBrowserUpdated,
    },
    {
      title: "Désinscriptions",
      path: "desinscriptions-admin",
      icon: RiMailForbidFill,
      badgeKey: "desinscriptions",
    },
    {
      title: "FAQ",
      path: "faq",
      icon: FaQuestionCircle,
    },
    {
      title: "Tâches",
      path: "tasks",
      icon: FaCheckCircle,
    },
    {
      title: "Suivi Clients",
      path: "suivi-clients",
      icon: BsKanban,
    },
  ],

  2: [
    {
      title: "Tutoriel MonAppliClub",
      path: "tutoriel",
      icon: FaBook,
    },
    {
      title: "Mon Association",
      path: "mon-association",
      icon: FaStar,
    },
    {
      title: "Formules Tarifaires",
      path: "tarifs",
      icon: FaEuroSign,
    },
  ],

  3: [
    {
      title: "Tutoriel MonAppliClub",
      path: "tutoriel",
      icon: FaBook,
    },
    {
      title: "Mon Association",
      path: "mon-association",
      icon: FaStar,
    },
    {
      title: "Formules Tarifaires",
      path: "tarifs",
      icon: FaEuroSign,
    },
  ],
};

export const DASHBOARD_EXTRA_ROUTES = [
  { title: "Notifications", path: "notifications" },
  { title: "Inscription association", path: "inscription-association" },
  { title: "Mon profil", path: "profil" },
  { title: "Tâches", path: "tasks" },
  { title: "Progression", path: "progression" },
  { title: "Cartographie clients", path: "carto-clients" },
];

export function getMenusForRole(roleId) {
  return DASHBOARD_MENUS[roleId] || DASHBOARD_MENUS[2];
}

export function buildDashboardPath(path = "") {
  const cleanPath = String(path).replace(/^\/+/, "");
  return `${DASHBOARD_BASE_PATH}/${cleanPath}`;
}

export function isDashboardPathActive(currentPathname, menuPath) {
  const fullPath = buildDashboardPath(menuPath);
  return (
    currentPathname === fullPath || currentPathname.startsWith(`${fullPath}/`)
  );
}

export function getActiveDashboardItem(currentPathname, roleId) {
  const allItems = [...getMenusForRole(roleId), ...DASHBOARD_EXTRA_ROUTES];

  return (
    allItems.find((item) =>
      isDashboardPathActive(currentPathname, item.path),
    ) || null
  );
}
